var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKorean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.3335H0.5V39.6668H47.5V8.3335Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5173 28.3452C32.9171 24.7455 31.9444 19.8821 28.3448 17.4823C24.7451 15.0825 19.8816 16.0552 17.4819 19.6549C15.0821 23.2545 16.0548 28.118 19.6544 30.5178C23.2541 32.9175 28.1176 31.9448 30.5173 28.3452Z",
    fill: "#CD2E3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4819 19.655C16.282 21.4548 16.7683 23.8866 18.5682 25.0864C20.368 26.2863 22.7997 25.8 23.9996 24.0002C25.1995 22.2003 27.6312 21.714 29.431 22.9139C31.2309 24.1137 31.7172 26.5455 30.5173 28.3453C28.1176 31.9449 23.2541 32.9176 19.6545 30.5179C16.0548 28.1181 15.0821 23.2546 17.4819 19.655Z",
    fill: "#0047A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5069 20.3788L15.8521 13.8611L11.5069 20.3788Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4053 36.311L39.7504 29.7933L35.4053 36.311Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8521 34.1384L11.5069 27.6207L15.8521 34.1384Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7504 18.2062L35.4053 11.6885L39.7504 18.2062Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2363 32.5093L12.8658 31.423L11.2363 32.5093ZM33.2336 17.8444L35.1346 16.5771L33.2336 17.8444ZM36.7641 15.4908L38.3935 14.4045L36.7641 15.4908Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2324 30.1558L38.6639 33.7767L33.2324 30.1558Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9266 11.3413L40.2718 17.859L39.2289 18.5543L34.8838 12.0365L35.9266 11.3413ZM13.1146 12.0365L8.7694 18.5543L7.72656 17.859L12.0717 11.3413L13.1146 12.0365ZM14.744 13.1228L10.3988 19.6405L9.35599 18.9453L13.7011 12.4276L14.744 13.1228ZM34.2972 12.4276L38.6423 18.9453L37.5995 19.6405L33.2543 13.1228L34.2972 12.4276ZM16.3734 14.2091L12.0283 20.7268L10.9854 20.0316L15.3306 13.5139L16.3734 14.2091ZM32.6677 13.5139L37.0129 20.0316L35.9701 20.7268L31.6249 14.2091L32.6677 13.5139ZM37.0129 27.9688L32.6677 34.4865L31.6249 33.7913L35.9701 27.2735L37.0129 27.9688ZM12.0283 27.2735L16.3734 33.7913L15.3306 34.4865L10.9854 27.9688L12.0283 27.2735ZM38.6423 29.055L34.2972 35.5728L33.2543 34.8775L37.5995 28.3598L38.6423 29.055ZM10.3988 28.3598L14.744 34.8775L13.7011 35.5728L9.35599 29.055L10.3988 28.3598ZM40.2718 30.1413L35.9266 36.6591L34.8838 35.9638L39.2289 29.4461L40.2718 30.1413ZM8.7694 29.4461L13.1146 35.9638L12.0717 36.6591L7.72656 30.1413L8.7694 29.4461Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0033 32.1618L12.6327 31.0755L13.0962 31.7708L11.4668 32.8571L11.0033 32.1618ZM35.3652 16.9248L33.4642 18.1922L33.0007 17.4969L34.9017 16.2296L35.3652 16.9248ZM38.6241 14.7522L36.9946 15.8385L36.5311 15.1433L38.1606 14.057L38.6241 14.7522Z",
    fill: "#F0F0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4324 34.1244L33.001 30.5034L33.4645 29.8082L38.8959 33.4292L38.4324 34.1244Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorean);
export default __webpack_public_path__ + "static/media/Korean.410a7b68.svg";
export { ForwardRef as ReactComponent };